

import { defineComponent, ref, watch, onMounted, Ref } from "vue";
import useEmitter from "@/composables/Emmiter";
import { useStore } from "vuex";
import FilterBase from "@/layout/header/partials/filters/FilterBase.vue";
import Api from "@/services/Api";
import { ElConfigProvider } from "element-plus";
import ptBr from "element-plus/lib/locale/lang/pt-br";

interface Lubrificante {
  marca: string;
  produto: string;
  viscosidade: string;
  tipo: string;
}

export default defineComponent({
  name: "FilterLubrificantes",
  components: {
    FilterBase,
    ElConfigProvider,
  },

  setup(props, { emit }) {
    const store = useStore();
    const emitter = useEmitter();
    const closeModal = ref(false);
    const spanWarning = ref(false);
    const marcasDeLubrificantes: Ref<any> = ref([]);

    const planosSelect: Ref<any> = ref([]);
    const paramsFilter: Ref<Lubrificante> = ref({
      marca: "",
      produto: "",
      viscosidade: "",
      tipo: "",
    })

    async function getMarcasProduto(){
      try{
        const { data } = await Api.get("getMarcasProdutoDbInfo", {tipoProduto: 'oleoMotor'});
        if(data.length === 0) {
          marcasDeLubrificantes.value = "No data";
        } else {
          marcasDeLubrificantes.value = data;
        }
      }catch(err){
        console.log(err);
      }
    }

    async function enviarEmit() {
      await emitter.emit("paramsFilter", {
        paramsFilter: paramsFilter.value,
      });
      closeModal.value = !closeModal.value;
    }

    onMounted(() => {
      getMarcasProduto()
    });

    // watch(() => paramsFilter.value, () => {console.log('aqui', paramsFilter.value)}, {deep:true}) 

    return { spanWarning, marcasDeLubrificantes, enviarEmit, ElConfigProvider, ptBr, paramsFilter, planosSelect, closeModal };
  },
});
